angular.module('dnecom')
    .filter('timerRemaining', function() {

        return function(timer, timezone) {
            if (timer.timer_type != "global") {
                return '';
            }

            var targetDateString = moment(
                timer.timer_date + ' ' + timer.timer_time + ' ' + timer.timer_suffix,
                'MM/DD/YYYY hh:mm a'
            ).format('YYYY-MM-DD HH:mm:ss');

            var targetDateInPST = moment.tz(targetDateString, timezone);

            var endDate = targetDateInPST.tz(moment.tz.guess());

            moment.updateLocale('en', {
                relativeTime : {
                    future: "in %s",
                    past:   "%s ago",
                    s:  "seconds",
                    m:  "a minute",
                    mm: "%d min",
                    h:  "an hour",
                    hh: "%d hours",
                    d:  "a day",
                    dd: "%d days",
                    M:  "a month",
                    MM: "%d months",
                    y:  "a year",
                    yy: "%d years"
                }
            });

            var currentDate = moment();
            var remaining = null;

            if (currentDate.isAfter(endDate)) {
                return "Expired";
            } else {
                return currentDate.to(endDate, true) + ' remaining';
            }
        };
    });
